export const studentLevelOptions = [
  { value: 'SEM INFO', label: 'SEM INFO' },
  { value: 'SEDENTÁRIO', label: 'SEDENTÁRIO' },
  { value: 'INICIANTE', label: 'INICIANTE' },
  { value: 'INTERMEDIÁRIO', label: 'INTERMEDIÁRIO' },
  { value: 'AVANÇADO', label: 'AVANÇADO' },
  { value: 'ATLETA', label: 'ATLETA' },
];

export const objectiveOptions = [
  { value: 'CONDICIONAMENTO', label: 'CONDICIONAMENTO' },
  { value: 'EMAGRECIMENTO', label: 'EMAGRECIMENTO' },
  { value: 'ESTÉTICA', label: 'ESTÉTICA' },
  { value: 'HIPERTROFIA', label: 'HIPERTROFIA' },
  { value: 'QUALIDADE DE VIDA', label: 'QUALIDADE DE VIDA' },
];

export const frequencyOptions = [
  { value: '1x', label: '1x' },
  { value: '2x', label: '2x' },
  { value: '3x', label: '3x' },
  { value: '4x', label: '4x' },
  { value: '5x', label: '5x' },
  { value: '6x', label: '6x' },
  { value: '7x', label: '7x' },
];

export const availableTimeOptions = [
  { value: '20-30', label: '20-30"' },
  { value: '30', label: '30"' },
  { value: '30-45', label: '30-45"' },
  { value: '45-60', label: '45-60"' },
  { value: '60-90', label: '60-90"' },
  { value: '90+', label: '+ DE 90"' },
];

export const scheduleOptions = [
  { value: 'manha', label: 'Manhã' },
  { value: 'tarde', label: 'Tarde' },
  { value: 'noite', label: 'Noite' },
];

export const genderOptions = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Feminino' },
  { value: 'other', label: 'Outro' },
];

export const studentLevelCodes = [
  { value: 'SEDENTÁRIO', label: 'NT01' },
  { value: 'INICIANTE', label: 'NT02' },
  { value: 'INTERMEDIÁRIO', label: 'NT03' },
  { value: 'AVANÇADO', label: 'NT04' },
  { value: 'SEM INFO', label: 'NT00' },
  { value: 'ATLETA', label: 'NT05' },
];

export const objectiveCodes = [
  { value: 'CONDICIONAMENTO', label: 'OT01' },
  { value: 'EMAGRECIMENTO', label: 'OT02' },
  { value: 'ESTÉTICA', label: 'OT03' },
  { value: 'HIPERTROFIA', label: 'OT04' },
  { value: 'QUALIDADE DE VIDA', label: 'OT05' },
];

export const frequencyCodes = [
  { value: '1x', label: 'FQ01' },
  { value: '2x', label: 'FQ02' },
  { value: '3x', label: 'FQ03' },
  { value: '4x', label: 'FQ04' },
  { value: '5x', label: 'FQ05' },
  { value: '6x', label: 'FQ06' },
  { value: '7x', label: 'FQ07' },
];

export const availableTimeCodes = [
  { value: '20-30', label: 'TA01' },
  { value: '30', label: 'TA02' },
  { value: '30-45', label: 'TA03' },
  { value: '45-60', label: 'TA04' },
  { value: '60-90', label: 'TA05' },
  { value: '90+', label: 'TA06' },
];

export const genderCodes = [
  { value: 'male', label: 'SX01' },
  { value: 'female', label: 'SX02' },
  { value: 'others', label: 'SX03' },
  { value: null, label: 'SX00' },
];

export const physicalEvaluationCodes = [
  { value: 'BAIXO PESO', label: 'AV01' },
  { value: 'PESO NORMAL', label: 'AV02' },
  { value: 'ACIMA DO PESO', label: 'AV03' },
  { value: 'OBESIDADE 01', label: 'AV04' },
  { value: 'OBESIDADE 02', label: 'AV05' },
  { value: 'OBESIDADE 03', label: 'AV06' },
];
